import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const ImportFamiliesMutation = graphql.persisted(
  "ImportFamiliesMutation",
  graphql(`
    mutation ImportFamiliesMutation($input: ImportFamiliesInput!) {
      importFamilies(input: $input) {
        importedCount
        errors
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { ImportFamiliesMutation };

export function useImportFamilies() {
  return useMutation(ImportFamiliesMutation);
}
